<template>
  <div>
    <div v-if="loadingPocs">
      <img class="d-none d-lg-block brand-DesktopMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/DesktopMag.svg" alt=""
        srcset="">
      <img class="d-none d-md-block d-lg-none brand-TabletMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/TabletMag.svg" alt=""
        srcset="">
      <img class="d-block d-md-none brand-MobileMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/MobileMag.svg" alt=""
        srcset="">
    </div>
    <div v-if="!loadingPocs && pocs && pocs.length">
      <h2 class="h4 font-weight-bold py-4">{{ $t('Partners.content') }}</h2>
      <div class="row flex-wrap">
        <div class="col-lg-3 col-sm-6 col-12 mb-3" v-for="(singlePoc, i) in pocs" :key="i">
          <singlePoc :singlePoc="singlePoc" :realUrl="singlePoc.realUrl" :isDevMioActive="isDevMioActive" :key="i" />
        </div>
      </div>
      <div v-if="canLoadMorePocs && !loadingMorePocs" class="text-center mb-3">
        <button class="btn btn-primary" @click="getPocsData">
          <span>{{ $t('Partners.showMore') }}</span>
        </button>
      </div>
    </div>
        <div v-if="loadingMorePocs">
      <img class="d-none d-lg-block brand-DesktopMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/DesktopMag.svg" alt=""
        srcset="">
      <img class="d-none d-md-block d-lg-none brand-TabletMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/TabletMag.svg" alt=""
        srcset="">
      <img class="d-block d-md-none brand-MobileMag"
        src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/MobileMag.svg" alt=""
        srcset="">
    </div>
  </div>
</template>
<script>
import singlePoc from "../../brand/SinglePoc.vue";
import { useQuery } from "@vue/apollo-composable";
import CONCORD_QUERIES from "../../../services/concord_queries.js";
import { watch } from 'vue';
import helperfunctions from "../../../services/helperfunctions.js";

export default {
  name: 'InhalteTab',
  components: {
    singlePoc
  },

  props: {
    settingsPerm: Object,
    partnerDetails: Object,
  },

  data() {
    return {
      isDevMioActive: this.settingsPerm.isDevMioActive,
      pocs: [],
      loadingPocs: false,
      loadingMorePocs: false,
      canLoadMorePocs: true,
      page: 1,
      pageSize: 16,
    };
  },

  created() {
    this.getPocsData();
  },

  methods: {
    getPocsData() {
      if (this.page && this.page > 1) {
        this.loadingMorePocs = true;
      } else {
        this.loadingPocs = true;
      }
      let variablesForQuery = {
        platformPartnerId: this.partnerDetails._id,
        page: this.page,
        pageSize: this.pageSize,
      };

      const {
        result
      } = useQuery(CONCORD_QUERIES.GET_POCS_FOR_PARTNER_BY_PARTNTERID, variablesForQuery);
      watch(result, value => {
        if (value && value.retrieval && value.retrieval.results && value.retrieval.results.length) {
          if (value.retrieval.results.length < this.pageSize) {
            this.canLoadMorePocs = false;
          }
          value.retrieval.results.forEach((poc) => {
            this.pocs.push({ ...poc, realUrl: helperfunctions.generateUrlForPocs(poc) });
          });
          this.loadingMorePocs = false;
          this.loadingPocs = false;
          this.page++;
        } else {
          this.loadingMorePocs = false;
          this.loadingPocs = false;
          this.canLoadMorePocs = false;
        }
      })
    }
  },

};
</script>

<style></style>